import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { parse, isValid, format } from 'date-fns';
import { FaWhatsapp } from 'react-icons/fa'; // Importe o ícone do WhatsApp do React Icons
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import { useRef } from 'react'; // Já deve ter, mas reforçando
import { FaTrash } from 'react-icons/fa';
import equipamentos from './components/equipamentos'
import perguntasFrequentes from './components/perguntasFrequentes'
import Header from './Header';
import Filter from './components/Filter';

// 🔕 DESATIVAR TOASTS GLOBALMENTE (sem remover as chamadas no código)
const DISABLE_TOASTS = true;
if (DISABLE_TOASTS && typeof toast === 'object') {
  const noop = () => {};
  toast.success = noop;
  toast.info = noop;
  toast.error = noop;
  toast.warn = noop;
}


registerLocale("pt-BR", ptBR);

function EstoqueEquipamentos() {
  const [equipamentosState, setEquipamentosState] = useState(equipamentos);

  return (
    <div>
      {equipamentosState.map((equipamento, index) => (
        <div key={index}>
          <h2>{equipamento.nome}</h2>
          <p>{equipamento.descricao}</p>
        </div>
      ))}
    </div>
  );
}




function App() {


  const [nome, setNome] = useState("");
  const [data, setData] = useState("");
  const nomeRef = useRef(null);
  const localRef = useRef(null);
  const dataRef = useRef(null);
  const [reservas, setReservas] = useState([]); // Reservas obtidas da Google Sheets ou de um backend
  const [mostrarCamposEvento, setMostrarCamposEvento] = useState(false);
  const [mostrarModalEvento, setMostrarModalEvento] = useState(false);
  const [menuAberto, setMenuAberto] = useState(false);
  

  useEffect(() => {
  if (!data) return;

  console.log("Data selecionada:", data);

  // Atualiza reservas para essa data,
  // mas NÃO zera mais o carrinho
  consultarReservas();
}, [data]);


  const consultarReservas = async () => {
    const SHEET_ID = "1RRDm8QhFriucaARH_IX8oMjepsBGnc3OFWS_srcSVCs";
    const API_KEY = "AIzaSyDSxMBMrzsYw7BOUKlH3rOaMbSmXbYACdo";
    const RANGE = "Reservas!A2:E";

    try {
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;
      console.log("🔄 Consultando planilha do Google Sheets...");

      const response = await fetch(url);
      const dataAPI = await response.json();

      if (!dataAPI.values) {
        console.warn("⚠️ Nenhum dado retornado da planilha.");
        setReservas([]);
        return;
      }

      const todasAsReservas = dataAPI.values.map((linha) => ({
        id_reserva: linha[0] || "",
        data: linha[1] || "",
        id_equipamento: linha[2] || "",
        nome: linha[3] || "",
        quantidade: parseInt(linha[4], 10) || 0
      }));

      // ➕ Normalizar data para dd-MM-yyyy
      const normalizarData = (str) => {
        const limpa = str.replace(/\//g, "-").trim();
        const parsed = parse(limpa, 'dd-MM-yyyy', new Date());
        return isValid(parsed) ? format(parsed, 'dd-MM-yyyy') : '';
      };

      const dataFormatada = normalizarData(data);
      const reservasFiltradas = todasAsReservas.filter(r => normalizarData(r.data) === dataFormatada);

      console.log("✅ Reservas carregadas da planilha:", reservasFiltradas);
      setReservas(reservasFiltradas);
    } catch (error) {
      console.error("❌ Erro ao consultar planilha do Google Sheets:", error);
      setReservas([]);
    }
  };

  // useEffect para monitorar quando o estado de reservas mudar
  useEffect(() => {
    console.log("Reservas após atualização do estado:", reservas); // Verifique o estado atualizado
  }, [reservas]); // Esse useEffect será chamado sempre que reservas for atualizado

  
  const calcularQuantidadeDisponivel = (equipamento) => {
    const reservasDoEquipamento = reservas.filter(
      (reserva) => reserva.id_equipamento === equipamento.id
    );

    const quantidadeReservada = reservasDoEquipamento.reduce(
      (total, reserva) => total + reserva.quantidade,
      0
    );

    const quantidadeDisponivel = equipamento.max - quantidadeReservada;

    return quantidadeDisponivel >= 0 ? quantidadeDisponivel : 0;
  };



  const [modalInfoAberto, setModalInfoAberto] = useState(false);
  const [mostrarModalDescricao, setMostrarModalDescricao] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [equipamentoSelecionado, setEquipamentoSelecionado] = useState(null);
  const [local, setLocal] = useState("");
  const dadosEventoPreenchidos = () => {
    return nome.trim() !== "" && local.trim() !== "" && data.trim() !== "";
  };
  // helpers para criar mapas { [id]: valor }
const buildQtyMap = (valor = "") =>
  Object.fromEntries(equipamentos.map(e => [e.id, valor]));
const buildBoolMap = (valor = false) =>
  Object.fromEntries(equipamentos.map(e => [e.id, valor]));

const [quantidades, setQuantidades] = useState(buildQtyMap(""));
const [erros, setErros] = useState(buildBoolMap(false));
  const [infoVisivel, setInfoVisivel] = useState(Array(equipamentos.length).fill(false));
  const [startDate, setStartDate] = useState(null); // Estado para controlar a data
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [subtotal, setSubtotal] = useState(0);
  const [informacoesAdicionais, setInformacoesAdicionais] = useState("");
  const [categoriaAtiva, setCategoriaAtiva] = useState('TODOS');

    const normalizarTexto = (texto) => {
    if (!texto) return "";
    return String(texto)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  };

  const normalizarCategoria = (categoria) => {
    return normalizarTexto(categoria);
  };

const formatMesAno = (d) => {
  const s = format(d, "LLLL yyyy", { locale: ptBR }); // ex.: "novembro 2025"
  return s.charAt(0).toUpperCase() + s.slice(1);     // "Novembro 2025"
};
  const handleFilter = (categoria) => {
  setCategoriaAtiva(categoria);
};

  const [formTocados, setFormTocados] = useState({ nome: false, local: false, data: false });

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
useEffect(() => {
  const handleResize = () => {
    setIsDesktop(window.innerWidth >= 768);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  const [formErros, setFormErros] = useState({ nome: false, local: false, data: false });

  useEffect(() => {
    setFormErros({
      nome: formTocados.nome && !nome.trim(),
      local: formTocados.local && !local.trim(),
      data: formTocados.data && !data.trim(),
    });
  }, [nome, local, data, formTocados]);

  const scrollListaRef = useRef(null);
const [hintTop, setHintTop] = useState(false);
const [hintBottom, setHintBottom] = useState(false);

const recomputeHints = () => {
  const el = scrollListaRef.current;
  if (!el) return;
  const { scrollTop, scrollHeight, clientHeight } = el;

  // Mostra chevron superior se não está no topo
  setHintTop(scrollTop > 2);

  // Mostra chevron inferior se ainda há conteúdo abaixo
  setHintBottom(scrollTop + clientHeight < scrollHeight - 2);
};

  const [carrinho, setCarrinho] = useState([]);
  const [isMiniCartOpen, setIsMiniCartOpen] = useState(false); // Novo estado para controlar a visibilidade
  const [animatingImage, setAnimatingImage] = useState(null);
  const [mainContainerClass, setMainContainerClass] = useState('');
  const [imagemAmpliada, setImagemAmpliada] = useState(null);
  const [imagemAmpliadaAlt, setImagemAmpliadaAlt] = useState('');
  const [isCarrinhoAberto, setIsCarrinhoAberto] = useState(false);
  // força abrir carrinho modal
const abrirCarrinho = () => {
  setIsCarrinhoAberto(true);   // garante que o carrinho tem conteúdo visível
  setIsMiniCartOpen(true);     // mostra o modal lateral
};

// força fechar carrinho modal
const fecharCarrinho = () => {
  setIsMiniCartOpen(false);
};
  
  const [isScrolled, setIsScrolled] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    // tenta pegar scroll do window
    const yWin = window.scrollY ?? window.pageYOffset ?? 0;

    // tenta pegar scroll do <html> / <body>
    const yDoc =
      document.documentElement?.scrollTop ??
      document.body?.scrollTop ??
      0;

    // pega o maior valor
    const y = Math.max(yWin, yDoc);

    // Fallback adicional:
    // se o conteúdo total da página já é bem maior que a viewport
    // vamos assumir que o usuário "está longe do topo" quando y >= 1
    const pageHeight = document.documentElement?.scrollHeight || 0;
    const viewportHeight = window.innerHeight || 0;
    const podeRolar = pageHeight - viewportHeight > 40; // já tem conteúdo para rolar?

    if (y > 20 || (podeRolar && y > 1)) {
      if (!isScrolled) setIsScrolled(true);
    } else {
      if (isScrolled) setIsScrolled(false);
    }
  };

  // roda ao montar, pra já setar algo
  handleScroll();

  // ouve scroll no window
  window.addEventListener("scroll", handleScroll, { passive: true });

  // alguns layouts usam scroll no body/html
  document.addEventListener("scroll", handleScroll, { passive: true });

  return () => {
    window.removeEventListener("scroll", handleScroll);
    document.removeEventListener("scroll", handleScroll);
  };
}, [isScrolled]);
  const [carrinhoAbertoAutomaticamente, setCarrinhoAbertoAutomaticamente] = useState(false);
  useEffect(() => {
    if (isMiniCartOpen) {
      setMainContainerClass('mini-cart-open');
    } else {
      setMainContainerClass('');
    }
  }, [isMiniCartOpen]);
  // ⬇️⬇️ COLE ESTE TRECHO AQUI ⬇️⬇️
// Bloquear rolagem do body quando modais/mini-carrinho estiverem abertos
useEffect(() => {
  const algumOverlayAberto =
    mostrarModalEvento || mostrarModalDescricao || (isMiniCartOpen && isCarrinhoAberto);

  const prevOverflow = document.body.style.overflow;
  if (algumOverlayAberto) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = prevOverflow || '';
  }
  return () => { document.body.style.overflow = prevOverflow || ''; };
}, [mostrarModalEvento, mostrarModalDescricao, isMiniCartOpen, isCarrinhoAberto]);
// ⬆️⬆️ AQUI ⬆️⬆️
  const [itemRemovendo, setItemRemovendo] = useState(null);
  const [itemParaRemover, setItemParaRemover] = useState(null);
  const temItensNoCarrinho = carrinho.length > 0;
  const [mostrarModalRemoverItem, setMostrarModalRemoverItem] = useState(false);
  const abrirModalRemoverItem = (item) => {
    setItemParaRemover(item); // Define o item a ser removido
    setMostrarModalRemoverItem(true); // Exibe o modal de confirmação
  };
  const removerItemConfirmado = () => {
    setCarrinho(carrinho.filter((item) => item.nome !== itemParaRemover.nome)); // Remove o item do carrinho
    setMostrarModalRemoverItem(false); // Fecha o modal de remoção
    setItemParaRemover(null); // Limpa o item a ser removido

    // Limpa a quantidade do item removido no estado "quantidades"
    const updatedQuantidades = [...quantidades];
    const itemIndexToUpdate = equipamentos.findIndex((equipamento) => equipamento.nome === itemParaRemover.nome);
    if (itemIndexToUpdate !== -1) {
      updatedQuantidades[itemIndexToUpdate] = ""; // Zera a quantidade do item no estado
      setQuantidades(updatedQuantidades); // Atualiza o estado de quantidades
    }

    // ✅ Mostra o toast de remoção
    toast.info(`${itemParaRemover.nome} removido do carrinho.`);
  };

  const cancelarRemocaoItem = () => {
    setMostrarModalRemoverItem(false); // Fecha o modal
    setItemParaRemover(null); // Limpa o item a ser removido
  };
  const botaoCarrinhoRef = useRef(null);
  const botaoCarrinhoHeaderRef = useRef(null);

  const [modalEnviando, setModalEnviando] = useState(false);
const miniCarrinhoVisivel = isMiniCartOpen && isCarrinhoAberto;
  const removerItemDoCarrinho = (itemParaRemover) => {
    const itemIndex = carrinho.findIndex(item => item.nome === itemParaRemover.nome);
    if (itemIndex === -1) return;

    // Aplica a classe de animação
    const carrinhoAnimado = carrinho.map((item, index) =>
      index === itemIndex ? { ...item, removendo: true } : item
    );
    setCarrinho(carrinhoAnimado);

    // Força um repaint antes do setTimeout (essencial para CSS aplicar)
    requestAnimationFrame(() => {
      setTimeout(() => {
        setCarrinho(carrinho => carrinho.filter(item => item.nome !== itemParaRemover.nome));

        const updatedQuantidades = [...quantidades];
        const itemIndexToUpdate = equipamentos.findIndex((equipamento) => equipamento.nome === itemParaRemover.nome);
        if (itemIndexToUpdate !== -1) {
          updatedQuantidades[itemIndexToUpdate] = 0;
          setQuantidades(updatedQuantidades);
        }

        toast.info(`${itemParaRemover.nome} removido do carrinho.`);
      }, 400); // tempo da animação
    });
  };

  const confirmarEsvaziarCarrinho = () => {
    // Esvaziar o carrinho e resetar as quantidades
    setCarrinho([]); // Limpa o carrinho
    setQuantidades(Array(equipamentos.length).fill("")); // Resetar as quantidades
    setItemRemovendo(null); // Reseta a variável de item removido
    setMostrarConfirmacaoEsvaziar(false); // Fecha o modal de confirmação
  };

  const tableHeaderStyle = {
    padding: '12px',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    color: '#555',
    fontSize: 16,
  };

  const tableRowStyle = {
    borderBottom: '1px solid #eee',

  };

  const tableCellStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'center', // Para centralizar horizontalmente
    verticalAlign: 'middle', // Para centralizar verticalmente
    fontWeight: 'bold', // Para deixar o número em negrito
    backgroundColor: '#f9f9f9', // Um fundo suave para a célula
    borderRadius: '8px', // Bordas arredondadas para um design mais moderno
    color: '#333', // Cor do texto
    fontSize: '16px', // Tamanho de fonte mais adequado para a célula
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Sombra suave para dar destaque à célula
  };

  const buttonClickEffect = {
    opacity: 0.7,
    transition: 'opacity 0.1s ease-in-out',
  };

  const totalItensCarrinho = carrinho.reduce((acc, item) => acc + item.quantidade, 0);
  const atualizarCarrinho = (itemDoEquipamento, quantidade, onRemover) => {
    const itemExistente = carrinho.find((i) => i.nome === itemDoEquipamento.nome);

    if (quantidade > 0) {
      if (itemExistente) {
        setCarrinho(
          carrinho.map((i) =>
            i.nome === itemDoEquipamento.nome ? { ...i, quantidade } : i
          )
        );
      } else {
        setCarrinho([
          ...carrinho,
          {
            nome: itemDoEquipamento.nome,
            quantidade: quantidade || 1,
            preco: itemDoEquipamento.preco,
            imagem: itemDoEquipamento.imagem,
          },
        ]);
      }
    } else {
      // ✅ Quantidade 0 → remover do carrinho e exibir toast
      setCarrinho(carrinho.filter((i) => i.nome !== itemDoEquipamento.nome));
      if (onRemover) onRemover(); // Chama callback de remoção
    }
  };

  const [mostrarConfirmacaoEsvaziar, setMostrarConfirmacaoEsvaziar] = useState(false);
  const [confirmarEsvaziarCallback, setConfirmarEsvaziarCallback] = useState(null);

  const handleIncrement = (item, e) => {
  const currentValue = parseInt(quantidades[item.id], 10) || 0;
  const maxQuantity = calcularQuantidadeDisponivel(item);

  if (currentValue < maxQuantity) {
    const novaQuantidade = currentValue + 1;

    // atualiza quantidade local por ID
    setQuantidades(prev => ({ ...prev, [item.id]: novaQuantidade }));

    // sincroniza com carrinho
    atualizarCarrinho(item, novaQuantidade);

    // limpa erro de estoque por ID
    setErros(prev => ({ ...prev, [item.id]: false }));

    // abre mini-carrinho na 1ª vez
    if (!isCarrinhoAberto) {
      setIsCarrinhoAberto(true);
      setIsMiniCartOpen(true);
    }

    setIsScrolled(true);           // garante botão flutuante visível
    flyToCart(e, item.imagem);     // animação
    toast.success(`${item.nome} adicionado ao orçamento!`);
  } else {
    // estouro de estoque
    setErros(prev => ({ ...prev, [item.id]: true }));
  }
};

  const botaoQtdStyle = (tipo) => ({
  backgroundColor: '#f0f0f0',
  border: '1px solid #ccc',
  borderRadius: tipo === "-" ? '5px 0 0 5px' : '0 5px 5px 0',
  padding: '0 10px',
  fontSize: '14px',
  height: '30px',
  lineHeight: '30px',
  boxSizing: 'border-box',
  opacity: 1,
  cursor: 'pointer',
});

  const handleDecrement = (item) => {
  const currentValue = parseInt(quantidades[item.id], 10) || 0;

  if (currentValue > 0) {
    const novaQuantidade = currentValue - 1;

    // atualiza quantidade local por ID
    setQuantidades(prev => ({ ...prev, [item.id]: novaQuantidade }));

    // sincroniza com carrinho
    atualizarCarrinho(item, novaQuantidade);

    // limpa estado de erro por ID
    setErros(prev => ({ ...prev, [item.id]: false }));

    if (novaQuantidade === 0) {
      toast.info(`${item.nome} removido do carrinho.`);
    } else {
      toast.info(`${item.nome}: quantidade reduzida para ${novaQuantidade}.`);
    }
  }
};

  const handleIncrementTable = (item) => {
    setCarrinho((prevCarrinho) => {
      return prevCarrinho.map((i) => {
        if (i.nome === item.nome) {
          const newQuantity = i.quantidade + 1;
          if (newQuantity <= item.max) {
            return { ...i, quantidade: newQuantity }; // Atualiza a quantidade do item
          }
        }
        return i;
      });
    });
  };

  
  // Função de decremento
  const handleDecrementTable = (item) => {
    const newCarrinho = carrinho.map((i) => {
      if (i.nome === item.nome) {
        const newQuantity = i.quantidade - 1;
        if (newQuantity >= 0) { // Verifica se a quantidade não é negativa
          return { ...i, quantidade: newQuantity }; // Atualiza a quantidade do item
        }
      }
      return i; // Retorna item inalterado
    });

    setCarrinho(newCarrinho); // Atualiza o carrinho
  };

  const handleQuantidadeChange = (e, i) => {
    if (!dadosEventoPreenchidos()) {
      setFormErros({
        nome: nome.trim() === "",
        data: data.trim() === "",
        local: local.trim() === "",
      });
      return;
    }

    const valor = e.target.value;

    if (/^\d*$/.test(valor)) {
      const novoValor = parseInt(valor) || 0;
      const valorAnterior = parseInt(quantidades[i]) || 0;

      const novasQuantidades = [...quantidades];
      novasQuantidades[i] = novoValor;
      setQuantidades(novasQuantidades);

      atualizarCarrinho(equipamentos[i], novoValor);

      // Lógica dos Toasts
      if (valorAnterior === 0 && novoValor > 0) {
        toast.success(`${equipamentos[i].nome} adicionado ao carrinho.`);
      } else if (valorAnterior > 0 && novoValor === 0) {
        toast.info(`${equipamentos[i].nome} removido do carrinho.`);
      }
    }
  };


  const abrirModalConfirmacaoEsvaziar = (callback) => {
    setMostrarConfirmacaoEsvaziar(true);
    setConfirmarEsvaziarCallback(() => callback);
  };

  useEffect(() => {
    const novoSubtotal = equipamentos.reduce((acc, item, index) => {
      const quantidade = parseInt(quantidades[index]) || 0;
      return acc + quantidade * item.preco;
    }, 0);
    setSubtotal(novoSubtotal);
  }, [quantidades]);

  const contatoGabal = {
    nome: "Fale com o Gabriel",
    telefone: "(62) 99246-1404",
    email: "comercial@gabal.com.br",
    mensagemBotao: "Falar com nossa equipe",
    imagem: process.env.PUBLIC_URL + "/images/foto-gabal.jpg"
  };

  const calcularTotal = () =>
  carrinho
    .reduce((total, item) => total + item.quantidade * item.preco, 0)
    .toFixed(2)
    .replace('.', ',');
  

  const montarMensagem = () => {
  const itensSelecionados = carrinho.map((item) => {
    const subtotal = (item.quantidade * item.preco).toFixed(2).replace('.', ',');
    return `• *${item.quantidade}x* ${item.nome}  —  ${item.quantidade} x R$${item.preco.toFixed(2).replace('.', ',')}/un. = *R$${subtotal}*`;
  }).join('\n');

  const dataFormatada = startDate ? moment(startDate).format('DD/MM/YYYY') : '';

  return (
    `Olá, meu nome é *${nome}*.\n` +
    `Gostaria de prosseguir com o orçamento de locação de equipamentos para o dia *${dataFormatada}*.\n` +
    `Local: *${local}*.\n\n` +
    `Itens:\n${itensSelecionados}\n\n` +
    `*Total Estimado: R$${calcularTotal()}*/dia` +
    (informacoesAdicionais ? `\n\nInformações Adicionais:\n${informacoesAdicionais}` : '')
  );
};

  const montarLinkWhatsapp = () => {
  const numero = "5562992461404";
  const mensagem = montarMensagem();
  return `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
};

  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    onClick={onClick}
    value={value || ''}
    placeholder="Data do Evento"
    readOnly
    className="form-control"
    style={{
      width: '100%',
      marginBottom: '15px',
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      fontSize: '16px'
    }}
  />
));
  const enviarWhatsapp = () => {
  // 1. Carrinho vazio? nem tenta
  if (carrinho.length === 0) {
    toast.error("Adicione pelo menos um item antes de solicitar orçamento.");
    return;
  }

  // 2. Falta nome/local/data? abre modal pra coletar
  if (!nome.trim() || !local.trim() || !data.trim()) {
    setMostrarModalEvento(true);
    return;
  }

  // 3. Tudo preenchido -> abre WhatsApp AGORA MESMO (sem timeout!)
  const link = montarLinkWhatsapp();

  // Tenta abrir em nova aba/janela
  const win = window.open(link, "_blank");

  // Se o navegador bloqueou popup, faz fallback abrindo na mesma aba
  if (!win || win.closed || typeof win.closed === "undefined") {
    window.location.href = link;
  }
};

  const renderDescricaoComNegrito = (descricao) => {
    const palavrasParaNegrito = ["potência", "grave", "ativa", "conjunto", "passiva", "watts", "w", "db", "dj", "mixer", "controladora", "parled", "dmx", "sem fio", "retorno", "torre", "electro-voice", "pioneer", "yamaha", "attack", "oversound", "armer", "kadosh"];
    return descricao.split(' ').map((palavra, index) => {
      const palavraLimpa = palavra.toLowerCase().replace(/[^a-zA-Z0-9áéíóúçãõ]/g, '');
      if (palavrasParaNegrito.includes(palavraLimpa)) {
        return <strong key={index}>{palavra} </strong>;
      }
      return <span key={index}>{palavra} </span>;
    });
  };

  const handleFaqClick = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleContatoClick = () => {
    window.open(`https://wa.me/5562992461404?text=Olá, gostaria de mais informações.`);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = estilos;
    document.head.appendChild(style);

    // ... seu código useEffect existente
  }, []);

  const estilos = `
    *,
    *:before,
    *:after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    body { /* Adicione isso para garantir que o body também tenha box-sizing */
      box-sizing: border-box;
    }

    .main-container {
      max-width: 100%; /* Garante que não ultrapasse a largura do pai */
      margin: 40px auto;
      font-family: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
      padding: 10px;
      transition: margin-right 0.3s ease;
      /* Adiciona uma transição suave */
    }

    .main-container.mini-cart-open {
      margin-right: 350px;
      /* Largura do seu mini carrinho */
    }

    .form-container {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 10px;
      width: 100%;
    }

    .form-field {
      flex: 1;
      flex-basis: calc((100% - 10px) / 2); /* Dois campos por linha */
      max-width: 100%;
    }

    .form-control {
      width: 100%;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 16px;
    }

    /* Estilos para imagens responsivas */
    img {
      max-width: 100%;
      height: auto;
    }

    .card-equipamento {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-equipamento:hover {
  transform: scale(1.03); /* Zoom-in leve */
  box-shadow: 0 8px 16px rgba(0,0,0,0.15);
}

.item-carrinho {
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.botao-quantidade {
  transition: background-color 0.3s ease, transform 0.1s ease;
}
.botao-quantidade:active {
  transform: scale(0.9);
}

    @media (max-width: 600px) {
      .form-container {
        flex-direction: column;
        gap: 8px;
      }
      .form-field {
        flex-basis: 100%; /* Um campo por linha */
      }
      .form-control {
        padding: 6px;
        font-size: 14px;
      }
    }
  `;

  const estiloBotaoWhatsApp = {
    backgroundColor: '#25D366',
    color: 'white',
    padding: '12px',
    fontSize: '16px',
    width: '100%',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '10px',
  };

  const estiloBotaoEsvaziar = {
    backgroundColor: '#f44336',
    color: 'white',
    padding: '12px',
    fontSize: '16px',
    width: '100%',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '10px',
  };

  const estiloBotaoSair = {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '12px',
    fontSize: '16px',
    width: '100%',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  };

  const flyToCart = (e, imagemSrc) => {
  if (!e?.currentTarget) return;

  // cria o fantasma da imagem
  const img = document.createElement('img');
  img.src = imagemSrc;
  img.style.position = 'absolute';
  img.style.width = '80px';
  img.style.height = '80px';
  img.style.zIndex = 2000;
  img.style.pointerEvents = 'none';
  img.style.transition = 'all 1s ease-in-out';
  img.style.opacity = '1';

  // ponto inicial = botão que foi clicado
  const rectOrigem = e.currentTarget.getBoundingClientRect();
  img.style.top = `${rectOrigem.top + window.scrollY}px`;
  img.style.left = `${rectOrigem.left + window.scrollX}px`;

  document.body.appendChild(img);

  // === DEFINIR O ALVO ===
  // Regras:
  // - Desktop: sempre mira no carrinho flutuante (botaoCarrinhoRef)
  // - Mobile:
  //    - topo (isScrolled === false): mira no carrinho do header (botaoCarrinhoHeaderRef)
  //    - após scroll (isScrolled === true): mira no carrinho flutuante

  let targetRect = null;

  const cartFloatingEl = botaoCarrinhoRef.current;
  const cartHeaderEl = botaoCarrinhoHeaderRef.current;

  const isElementVisible = (el) => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  if (isDesktop) {
    // desktop sempre mira no carrinho flutuante
    if (isElementVisible(cartFloatingEl)) {
      targetRect = cartFloatingEl.getBoundingClientRect();
    }
  } else {
    // mobile
    // prioridade 1: se o carrinho flutuante já está visível, mira nele
    if (isElementVisible(cartFloatingEl)) {
      targetRect = cartFloatingEl.getBoundingClientRect();
    }
    // prioridade 2: senão, mira no ícone do header
    else if (isElementVisible(cartHeaderEl)) {
      targetRect = cartHeaderEl.getBoundingClientRect();
    }
  }

  if (!targetRect) {
    // não achou alvo → só faz fade out rápido
    setTimeout(() => {
      img.style.opacity = '0';
      img.style.transform = 'scale(0.5)';
      setTimeout(() => img.remove(), 300);
    }, 10);
    return;
  }

  const cartTop = targetRect.top + window.scrollY;
  const cartLeft = targetRect.left + window.scrollX;

  // animação: voa até o carrinho e some
  requestAnimationFrame(() => {
    img.style.top = `${cartTop + 10}px`;
    img.style.left = `${cartLeft + 10}px`;
    img.style.width = '30px';
    img.style.height = '30px';
    img.style.opacity = '0';
  });

  const handleTransitionEnd = () => {
  img.remove();
  // aqui adiciona a classe de animação no botão do carrinho
  if (botaoCarrinhoRef.current) {
    botaoCarrinhoRef.current.classList.add('cart-icon-animating');
    // remover a classe após a animação pra permitir nova animação futura
    setTimeout(() => {
      botaoCarrinhoRef.current?.classList.remove('cart-icon-animating');
    }, 400); // igual ao tempo do @keyframes
  }
};
  img.addEventListener('transitionend', handleTransitionEnd);
};
  return (
    <div className={`main-container ${mainContainerClass}`} style={{ maxWidth: 1200, margin: "3px auto", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", padding: "6px" }}>
      <Header
  menuAberto={menuAberto}
  setMenuAberto={setMenuAberto}
  abrirCarrinho={abrirCarrinho}
  fecharCarrinho={fecharCarrinho}
  isScrolled={isScrolled}
  carrinhoHeaderRef={botaoCarrinhoHeaderRef}   // <-- ADICIONADO
/>
<div
  style={{
    position: 'fixed',
    top: isDesktop ? 10 : 20,
    right: 10,
    zIndex: 2147483647,
    pointerEvents: 'auto',
    display: isMiniCartOpen
      ? 'none'
      : (
          isDesktop
            ? 'block'
            : (
                (isScrolled || temItensNoCarrinho)
                  ? 'block'
                  : 'none'
              )
        ),
  }}
>
  {/* Wrapper relativo pra poder posicionar o badge */}
  <div style={{ position: 'relative', display: 'inline-block' }}>
    <button
      ref={botaoCarrinhoRef}
      onClick={() => {
        setIsMiniCartOpen(!isMiniCartOpen);

        if (botaoCarrinhoRef.current) {
          botaoCarrinhoRef.current.classList.add('botao-clicado');
          setTimeout(() => {
            if (botaoCarrinhoRef.current) {
              botaoCarrinhoRef.current.classList.remove('botao-clicado');
            }
          }, 200);
        }
      }}
      className="header-action-btn"
      aria-label="abrir carrinho flutuante"
      style={{
        opacity: 1,
        pointerEvents: 'auto',
        transition: 'opacity 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        borderRadius: 8,
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        border: '1px solid rgba(0,0,0,0.05)',
      }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: 24, height: 24 }}
      >
        <circle cx="9" cy="20" r="1" />
        <circle cx="17" cy="20" r="1" />
        <path d="M3 3h2l3.6 12.4a1 1 0 0 0 1 .6h7.8a1 1 0 0 0 1-.8l2-8H6" />
      </svg>
    </button>

    {/* Badge de quantidade */}
    {totalItensCarrinho > 0 && (
      <span
        style={{
          position: 'absolute',
          top: -6,
          right: -6,
          minWidth: '20px',
          height: '20px',
          padding: '0 6px',
          backgroundColor: '#0FC144',
          color: '#fff',
          borderRadius: '999px',
          border: '2px solid #fff',
          fontSize: '12px',
          fontWeight: '600',
          lineHeight: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        }}
      >
        {totalItensCarrinho}
      </span>
    )}
  </div>
</div>

{(isMiniCartOpen && isCarrinhoAberto) && (
  <div className="mini-cart">
    {/* Overlay clicável */}
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999,
      }}
      onClick={() => setIsMiniCartOpen(false)}
    />

    {/* Painel do mini-carrinho */}
    <div
  style={{
    position: 'fixed',
    top: 30,
    right: 10,              // ✅ sempre à direita
    left: 'auto',           // ✅ impede que alinhe à esquerda
    width: '90%',
    maxWidth: '400px',
    height: '75vh',
    backgroundColor: '#fff',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    zIndex: 1000,
  }}
>
      {/* Cabeçalho */}
      <div
        style={{
          padding: 15,
          backgroundColor: '#f1f1f1',
          textAlign: 'center',
          borderBottom: '1px solid #ccc',
          fontWeight: 'bold',
          fontSize: 18,
          flexShrink: 0, // nunca encolhe
          position: 'relative',
        }}
      >
        Seu Carrinho

        {/* Botão X para fechar */}
        <button
          onClick={() => setIsMiniCartOpen(false)}
          aria-label="Fechar"
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            width: 32,
            height: 32,
            border: '1px solid #ddd',
            background: '#f8f8f8',
            borderRadius: 8,
            cursor: 'pointer',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✕
        </button>
      </div>

      {/* Lista de Itens – SCROLL SEMPRE VISÍVEL NO DESKTOP */}
      <div
  style={{
    flex: 1,
    overflowY: 'scroll',                   // ✅ força o scroll (não some)
    WebkitOverflowScrolling: 'touch',      // ✅ rolagem fluida no iOS
    padding: '15px',
    // folga extra no fundo para não “bater” no rodapé + área segura
    paddingBottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
    scrollbarGutter: 'stable',             // ✅ reserva espaço do scrollbar (suporte moderno)
  }}
>
        {carrinho.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#777' }}>O carrinho está vazio.</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {carrinho.map((item, index) => (
              <li
  key={index}
  className={`item-carrinho ${item.removendo ? 'item-removendo' : ''}`}
  style={{
    marginBottom: '15px',
    paddingBottom: '15px',
    borderBottom: '1px solid #eee',
  }}
>
  {/* Linha principal: foto + texto (nome + qtd/preço/excluir) */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%',
    }}
  >
    {/* IMAGEM */}
    <img
      src={item.imagem}
      alt={item.nome}
      style={{
        width: '70px',
        height: '70px',
        objectFit: 'contain',
        borderRadius: '6px',
      }}
      onClick={() => {
        setImagemAmpliada(item.imagem);
        setImagemAmpliadaAlt(item.nome);
      }}
    />

    {/* TEXTO + QTD + PREÇO + LIXEIRA */}
    <div style={{ flexGrow: 1, minWidth: 0 }}>

      {/* Nome do item */}
      <div
        style={{
          fontSize: '14px',
          fontWeight: '400',
          marginBottom: '6px',
          textAlign: 'left',
        }}
      >
        {item.nome}
      </div>

      {/* Quantidade + preço + lixeira */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
        }}
      >
        <span style={{ fontSize: '14px', color: '#333' }}>
          Qtd: {item.quantidade}
        </span>

        <span style={{ fontSize: '14px', fontWeight: '600', color: '#25D366' }}>
          R$ {(item.quantidade * item.preco).toFixed(2).replace('.', ',')}
        </span>

        <button
          onClick={() => abrirModalRemoverItem(item)}
          style={{
            background: 'none',
            border: 'none',
            color: '#dc3545',
            cursor: 'pointer',
            fontSize: '18px',
          }}
        >
          <FaTrash />
        </button>
      </div>
    </div>
  </div>
</li>
            ))}
          </ul>
        )}
      </div>

      {/* Rodapé – sempre visível */}
      <div
  className="mini-cart-footer"
  style={{
    position: 'sticky',  // ✅ mantém o rodapé visível dentro do painel
    bottom: 0,
    padding: '16px',
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))', // ✅ respeita barra do Safari
    borderTop: '1px solid #eee',
    backgroundColor: '#fafafa',
    zIndex: 1,
  }}
>
        <div
          className="total-carrinho"
          style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 20, marginBottom: 15 }}
        >
          Total:{' '}
          <span style={{ color: '#25D366' }}>
            R${' '}
            {carrinho
              .reduce((total, it) => total + it.quantidade * it.preco, 0)
              .toFixed(2)
              .replace('.', ',')}
              /dia
          </span>
        </div>

        <button
          onClick={() => abrirModalConfirmacaoEsvaziar(() => confirmarEsvaziarCarrinho())}
          style={{
            backgroundColor: '#ff4d4f',
            color: 'white',
            width: '100%',
            padding: 12,
            border: 'none',
            borderRadius: 10,
            marginBottom: 10,
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            transition: 'background 0.3s',
          }}
        >
          🗑️ Esvaziar Carrinho
        </button>

        <button
          onClick={() => setIsMiniCartOpen(false)}
          style={{
            backgroundColor: '#1890ff',
            color: 'white',
            width: '100%',
            padding: 12,
            border: 'none',
            borderRadius: 10,
            marginBottom: 10,
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            transition: 'background 0.3s',
          }}
        >
          ➕ Adicionar mais itens
        </button>

        <button
          onClick={enviarWhatsapp}
          style={{
            backgroundColor: '#0FC144',
            color: 'white',
            width: '100%',
            padding: 12,
            border: 'none',
            borderRadius: 10,
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
            transition: 'background 0.3s',
          }}
        >
          💬 Solicitar orçamento
        </button>
      </div>
    </div>
  </div>
)}
      
      <Filter onFilter={handleFilter} />

      <div
        style={{
          width: '100%',
          overflowX: 'hidden',
          padding: '0 10px',
          boxSizing: 'border-box',
        }}
      >
        <div
          className="grid-equipamentos"
        >
          {equipamentos
  .filter(item => {
  const categAtiva = normalizarCategoria(categoriaAtiva);
  if (!categAtiva || categAtiva === 'todos') return true;
  // Suporta tanto string quanto array de categorias
  const categorias = Array.isArray(item.categoria) ? item.categoria : [item.categoria];
  return categorias.some(cat => normalizarCategoria(cat) === categAtiva);
})
  .map((item, i) => (
            <div
              key={i}
              className="card-equipamento"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 15,
                backgroundColor: "#fff",
                textAlign: "center",
              }}
            >
              {/* TOPO: Imagem e Nome */}
              <div style={{ flexGrow: 1 }}>
                <div
                  style={{
                    overflow: 'hidden',
                    borderRadius: '8px',
                    marginBottom: '10px',
                    cursor: 'zoom-in',
                    position: 'relative',
                  }}
                  onClick={() => {
                    setImagemAmpliada(item.imagem);
                    setImagemAmpliadaAlt(item.nome);
                  }}
                >
                  <img
                    src={item.imagem}
                    alt={item.nome}
                    style={{
                      width: "100%",
                      height: 180,
                      objectFit: "contain",
                      borderRadius: 6,
                      backgroundColor: "#ffffff",
                      transition: 'transform 0.3s ease',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                  />
                </div>

                <div
                  style={{
                    fontSize: "1.1em",
                    fontWeight: "bold",
                    marginBottom: 5,
                    minHeight: "48px",
                    textAlign: "center",
                    lineHeight: "1.3",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  {item.nome.split("\n").map((linha, idx) => (
                    <span key={idx}>{linha}</span>
                  ))}
                </div>

                <div style={{ marginBottom: 3 }}>
                  <span style={{ fontSize: "1.2em", fontWeight: 500, color: "#25D366" }}>
                    R${item.preco.toFixed(2).replace(".", ",")}
                  </span>
                  <span style={{ fontSize: "0.8em", color: "#777", marginLeft: 4 }}>/diária</span>
                </div>

                <div style={{ fontSize: "0.9em", color: "#777", marginBottom: 10 }}>
  Quantidade disponível: {calcularQuantidadeDisponivel(item)}
</div>
                
              </div>

              {/* BASE FIXA */}
              <div style={{ marginTop: "auto" }}>
                <div style={{
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
  flexWrap: 'wrap'
}}>
  <button
    onClick={() => handleDecrement(item)}
    style={botaoQtdStyle("-")}
  >-</button>

  <input
  type="text"
  className="form-control quantidade-input"
  value={(parseInt(quantidades[item.id], 10) || 0)}
  readOnly
  inputMode="none"
  onFocus={(e) => e.target.blur()}
  onKeyDown={(e) => e.preventDefault()}
  onClick={(e) => e.preventDefault()}
  aria-label="Quantidade selecionada"
  style={{
    width: '28px',
    height: '28px',
    padding: '0px',
    fontSize: '14px',
    textAlign: 'center',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    lineHeight: '25px',
    userSelect: 'none',
    caretColor: 'transparent'
  }}
/>

  <button
    onClick={(e) => handleIncrement(item, e)}
    style={botaoQtdStyle("+")}
  >+</button>

  <button
    onClick={() => {
      setModalItem(item);
      setMostrarModalDescricao(true);
    }}
    style={{
      fontSize: 12,
      height: '30px',
      padding: '0 12px',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: 5,
      color: '#333',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 1,
    }}
  >
    Mais Informações
  </button>
</div>

                {erros[item.id] && (
  <div style={{ color: "red", fontSize: "0.9em", textAlign: "center", marginTop: 5 }}>
    Máximo disponível: {calcularQuantidadeDisponivel(item)}
  </div>
)}

                <div
                  style={{
                    maxHeight: infoVisivel[i] ? "none" : "0px", // Mostra tudo quando expandido
                    overflow: "hidden",
                    transition: "max-height 0.5s ease",
                    fontSize: 14,
                    color: "#555",
                    marginTop: infoVisivel[i] ? 10 : 0,
                    padding: infoVisivel[i] ? "10px" : "0px",
                    borderTop: infoVisivel[i] ? "1px solid #eee" : "none",
                  }}
                  className={`descricao-expandida ${infoVisivel[i] ? "visivel" : ""}`}
                >
                  {renderDescricaoComNegrito(item.descricao)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container-resumo-orcamento">
        <h2 style={{ textAlign: 'center', fontSize: 24, color: '#333', marginTop: 5, marginBottom: 20 }}>Resumo do Orçamento</h2>
        {carrinho.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#777', fontSize: 16 }}>Seu carrinho está vazio.</p>
        ) : (
          <>


            <div className="tabela-resumo">

              {/* TABELA EM TELAS GRANDES */}
              <div className="resumo-desktop">
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 25, marginBottom: 15 }}>
                  <thead style={{ backgroundColor: '#f8f8f8' }}>
                    <tr>
                      <th style={tableHeaderStyle}>#</th>
                      <th style={tableHeaderStyle}>Item</th>
                      <th style={tableHeaderStyle}>Qtd.</th>
                      <th style={tableHeaderStyle}>Preço Unitário</th>
                      <th style={tableHeaderStyle}>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {carrinho.map((item, index) => (
                      <tr key={item.nome} style={tableRowStyle}>
                        <td style={tableCellStyle}>{index + 1}</td>
                        <td style={{ ...tableCellStyle, textAlign: 'left' }}>{item.nome}</td>
                        <td style={tableCellStyle}>
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {item.quantidade}
                            <button
                              onClick={() => abrirModalRemoverItem(item)}
                              style={{
                                background: 'none',
                                border: 'none',
                                color: '#dc3545',
                                cursor: 'pointer',
                                fontSize: '18px',
                                marginLeft: '10px',
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                        <td style={tableCellStyle}>R$ {item.preco.toFixed(2).replace('.', ',')}</td>
                        <td style={tableCellStyle}>R$ {(item.quantidade * item.preco).toFixed(2).replace('.', ',')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* CARDS EM TELAS PEQUENAS */}
              <div className="resumo-mobile">
                {carrinho.map((item, index) => (
                  <div className="item-resumo" key={index}>
                    {/* IMAGEM DO ITEM */}
                    <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                      <img
                        src={item.imagem}
                        alt={item.nome}
                        className="imagem-resumo"
                      />
                    </div>

                    {/* INFORMAÇÕES DO ITEM */}
                    <div className="linha-resumo"><strong>Item:</strong><span>{item.nome}</span></div>
                    <div className="linha-resumo"><strong>Qtd:</strong><span>{item.quantidade}</span></div>
                    <div className="linha-resumo"><strong>Unitário:</strong><span>R$ {item.preco.toFixed(2).replace('.', ',')}</span></div>
                    <div className="linha-resumo"><strong>Subtotal:</strong><span>R$ {(item.quantidade * item.preco).toFixed(2).replace('.', ',')}</span></div>

                    {/* BOTÃO REMOVER */}
                    <button className="remover-botao" onClick={() => abrirModalRemoverItem(item)}>Remover</button>
                  </div>
                ))}
              </div>
            </div>

            <div style={{
              marginTop: 10,
              marginBottom: 15,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              alignItems: 'left',
              fontWeight: 'bold',
              fontSize: 18
            }}>
              <span style={{ textAlign: 'right', paddingRight: '10px' }}>Total estimado:</span>
              <span style={{ textAlign: 'left' }}>
                R${carrinho.reduce((total, item) => total + item.quantidade * item.preco, 0).toFixed(2).replace('.', ',')}
              </span>
            </div>
          </>
        )}
      </div>
      <div style={{ marginBottom: 20 }}>
        <label htmlFor="informacoesAdicionais" style={{ display: 'block', marginTop: '10px', marginBottom: '10px', fontWeight: 'bold', color: '#555' }}>
          Informações Adicionais:
        </label>
        <textarea
          id="informacoesAdicionais"
          value={informacoesAdicionais}
          onChange={(e) => setInformacoesAdicionais(e.target.value)}
          placeholder="Tem alguma necessidade específica ou gostaria de adicionar alguma observação?"
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            boxSizing: 'border-box', // ESSENCIAL
            minHeight: '120px',
            lineHeight: '2',
            resize: 'vertical'
          }}
        />
      </div>

      {carrinho.length > 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            marginTop: 10,
            marginBottom: 10,
            flexWrap: 'wrap',
            maxWidth: '600px', // controla o tamanho máximo dos dois juntos
            width: '70%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <div
            className="botoes-final"
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              marginTop: 5,
              marginBottom: 5,
              flexWrap: 'wrap',
              maxWidth: '600px',
              width: '100%',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <button
              onClick={() => abrirModalConfirmacaoEsvaziar(() => confirmarEsvaziarCarrinho())}
              style={{
                width: '100%',
                backgroundColor: '#f44336',
                color: 'white',
                padding: '15px',
                fontSize: '16px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d32f2f'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f44336'}
            >
              🗑️ Esvaziar Carrinho
            </button>
          </div>

          <div style={{ flex: 1 }}>
            <button
              className="botao-carrinho"
              onClick={enviarWhatsapp}
              style={{
                width: '100%',
                backgroundColor: '#0FC144',
                color: 'white',
                padding: '15px',
                fontSize: '16px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#128C7E'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#25D366'}
            >
              <FaWhatsapp style={{ marginRight: '8px', fontSize: '1.2em' }} />
              Solicitar orçamento
            </button>
          </div>
        </div>
      )}
      <div style={{ marginTop: 40, borderTop: "1px solid #ccc", paddingTop: 20 }}>
        <h2 style={{ textAlign: "center", fontSize: 24, color: "#333", marginBottom: 30 }}>Perguntas Frequentes</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {perguntasFrequentes.map((faq, index) => (
            <li
              key={index}
              style={{
                marginBottom: 10,
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  padding: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  backgroundColor: '#f0f0f0',
                  borderBottom: openFaqIndex === index ? '1px solid #e0e0e0' : 'none',
                  transition: 'background-color 0.3s ease',
                }}
                onClick={() => handleFaqClick(index)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#25D366';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#f0f0f0';
                }}
              >
                <div className="numero-pergunta">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <strong style={{ fontSize: 16, color: '#555' }}>{faq.pergunta}</strong>
              </div>
              {openFaqIndex === index && (
                <div
                  style={{
                    padding: '15px',
                    fontSize: 14,
                    color: '#777',
                    lineHeight: 1.6,
                    textAlign: 'justify',
                  }}
                  dangerouslySetInnerHTML={{ __html: faq.resposta }}
                />
              )}
            </li>
          ))}
        </ul>
      </div>
      {/* Seção de Contato Direto */}
      <div style={{
        marginTop: 40,
        padding: 30,
        backgroundColor: '#ffffff',
        borderRadius: 8,
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: 22, color: '#555', marginBottom: 10 }}>Ainda está com dúvidas?</h2>
        <h3 style={{ fontSize: 18, color: '#777', marginBottom: 10 }}>{contatoGabal.nome}</h3>
        {/* Sua foto aqui */}
        <img src={process.env.PUBLIC_URL + "/images/foto-gabal.jpg"} alt="Foto do Gabriel" style={{ width: 150, height: 150, borderRadius: '50%', objectFit: 'cover', marginBottom: 15 }} />
        <p style={{ color: '#777', marginBottom: 10 }}>
          <strong style={{ fontWeight: 'bold', color: '#555', }}>Vamos conversar?</strong><br />
          Tel: <a href={`tel:${contatoGabal.telefone}`} style={{ color: '#25D366', textDecoration: 'none' }}>{contatoGabal.telefone}</a><br />
          Email: <a href={`mailto:${contatoGabal.email}`} style={{ color: '#25D366', textDecoration: 'none' }}>{contatoGabal.email}</a>
        </p>
        <button
          style={{
            backgroundColor: '#25D366',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: 5,
            cursor: 'pointer',
            fontSize: 16
          }}
          onClick={handleContatoClick}
        >
          {contatoGabal.mensagemBotao}
        </button>
      </div>
      {imagemAmpliada && (
        <div
          onClick={() => setImagemAmpliada(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            cursor: 'zoom-out',
          }}
        >
          <img
            src={imagemAmpliada}
            alt={imagemAmpliadaAlt || ''}
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: '10px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
              animation: 'fadeIn 0.4s ease'
            }}
          />
        </div>

      )}
      {modalEnviando && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '30px 40px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
              fontSize: '18px',
              color: '#333',
              animation: 'fadeIn 0.4s ease'
            }}
          >
            <div
              style={{
                marginBottom: '15px',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #0FC144', // Cor verde do WhatsApp
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  animation: 'spin 1s linear infinite',
                }}
              ></div>
            </div>
            Obrigado! Redirecionando para o WhatsApp...
          </div>
        </div>
      )}
      {mostrarConfirmacaoEsvaziar && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '30px 40px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
              animation: 'fadeIn 0.4s ease',
              maxWidth: '400px',
              width: '90%',
            }}
          >
            <h2 style={{ marginBottom: '20px', fontSize: '20px', color: '#333' }}>Confirmar Ação</h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
              Tem certeza que deseja <strong>esvaziar o carrinho</strong>?
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <button
                onClick={() => {
                  if (confirmarEsvaziarCallback) confirmarEsvaziarCallback();
                  setMostrarConfirmacaoEsvaziar(false);
                }}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d32f2f'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f44336'}
              >
                Sim, Esvaziar
              </button>
              <button
                onClick={() => setMostrarConfirmacaoEsvaziar(false)}
                style={{
                  backgroundColor: '#ccc',
                  color: '#333',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#bbb'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ccc'}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      {mostrarModalRemoverItem && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '30px 40px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
              animation: 'fadeIn 0.4s ease',
              maxWidth: '400px',
              width: '90%',
            }}
          >
            <h2 style={{ marginBottom: '20px', fontSize: '20px', color: '#333' }}>
              Confirmar Remoção
            </h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
              Tem certeza que deseja remover o item: <strong>{itemParaRemover?.nome}</strong>?
            </p>
            <div className="modal-botoes-remocao">
              <button
                onClick={removerItemConfirmado}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  marginRight: '10px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d32f2f'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f44336'}
              >
                Sim, Remover
              </button>
              <button
                onClick={cancelarRemocaoItem}
                style={{
                  backgroundColor: '#ccc',
                  color: '#333',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#bbb'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ccc'}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Botão flutuante do WhatsApp - Tirar dúvidas */}
      {!miniCarrinhoVisivel && (
  <a
    href="https://wa.me/5562992461404?text=Olá! Olá Gabriel. Preciso de ajuda para montar meu orçamento no site."
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#0FC144',
      color: '#fff',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '30px',
      zIndex: 9999,
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      cursor: 'pointer',
      textDecoration: 'none',
      transition: 'transform 0.2s ease',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    title="Tirar dúvidas no WhatsApp"
  >
    <FaWhatsapp />
  </a>
)}
      {/* <ToastContainer
  position="bottom-right"
  autoClose={2500}
  hideProgressBar={true}
  newestOnTop={false}
  closeOnClick
  pauseOnFocusLoss={false}
  draggable
  pauseOnHover
/> */}
      {modalInfoAberto && equipamentoSelecionado && (
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '500px',
            maxHeight: '80vh', // altura máxima do modal
            overflowY: 'auto', // ativa scroll se necessário
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
            animation: 'fadeIn 0.4s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}
        >
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
            {modalItem?.nome.split('\n')[1] || modalItem?.nome}
          </h2>

          <img
            src={modalItem?.imagem}
            alt={modalItem?.nome}
            style={{
              maxWidth: '100%',
              maxHeight: '250px',
              objectFit: 'contain',
              marginBottom: '15px',
            }}
          />

          <p style={{
            fontSize: '15px',
            lineHeight: 1.6,
            textAlign: 'justify',
            color: '#444',
            marginBottom: '20px'
          }}>
            {renderDescricaoComNegrito(modalItem?.descricao)}
          </p>

          <button
            onClick={() => setMostrarModalDescricao(false)}
            style={{
              backgroundColor: '#25D366',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            Fechar
          </button>

        </div>
      )}
      {mostrarModalDescricao && modalItem && (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      zIndex: 9999,

      // importante p/ iOS: permite rolar tudo se o conteúdo for maior que a viewport segura
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',

      // dar um respiro inferior pra não grudar atrás da barra do Safari
      padding: '16px',
      paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
    }}
  >
    <div
      style={{
        // caixa branca do modal
        backgroundColor: '#fff',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '420px',

        // altura máxima considerando topo fixo + rodapé fixo,
        // e descontando um pequeno marginTop virtual (16px)
        // isso evita que o footer fique fora da viewport útil
        maxHeight: 'calc(100dvh - 20px)',

        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        overflow: 'hidden', // mantém bordas arredondadas
      }}
    >
      {/* HEADER FIXO DO MODAL */}
      <div
        style={{
          padding: '16px 20px',
          borderBottom: '1px solid #eee',
          backgroundColor: '#fafafa',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '12px',
          flexShrink: 0, // nunca encolhe
        }}
      >
        <div
          style={{
            fontSize: '16px',
            fontWeight: '600',
            lineHeight: '1.4',
            color: '#222',
            textAlign: 'left',
            flex: 1,
            wordBreak: 'break-word',
          }}
        >
          {modalItem.nome.split('\n')[1] || modalItem.nome}
        </div>

        <button
          onClick={() => setMostrarModalDescricao(false)}
          style={{
  backgroundColor: '#f5f5f5',
  border: '1px solid #ddd',
  color: '#555',
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  fontSize: '16px',
  lineHeight: 1,
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  marginRight: window.innerWidth < 768 ? '30px' : '0px', // 👈 desloca pra dentro no mobile
}}
          aria-label="Fechar"
        >
          ✕
        </button>
      </div>

      {/* CONTEÚDO ROLÁVEL */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: '20px',
        }}
      >
        <img
          src={modalItem.imagem}
          alt={modalItem.nome}
          style={{
            maxWidth: '100%',
            maxHeight: '200px',
            objectFit: 'contain',
            marginBottom: '15px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />

        <p
          style={{
            fontSize: '14px',
            lineHeight: 1.6,
            textAlign: 'justify',
            color: '#444',
            marginBottom: '10px',
            wordBreak: 'break-word',
          }}
        >
          {renderDescricaoComNegrito(modalItem.descricao)}
        </p>
      </div>

      {/* RODAPÉ FIXO COM BOTÃO FECHAR */}
      <div
        style={{
          borderTop: '1px solid #eee',
          backgroundColor: '#fafafa',
          textAlign: 'center',
          flexShrink: 0, // impede esse footer de sumir pra fora do flex
          padding: '16px 20px',
          // 💡 padding extra dinâmico pra não ficar atrás da barra do Safari
          paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        <button
          onClick={() => setMostrarModalDescricao(false)}
          style={{
            backgroundColor: '#25D366',
            color: 'white',
            width: '100%',
            padding: '12px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
)}
    {mostrarModalEvento && (
  <>
    {/* Overlay (fecha ao clicar fora) */}
    <div
      onClick={() => setMostrarModalEvento(false)}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 99999,
        backdropFilter: 'blur(3px)',
      }}
    />

    {/* Caixa do modal CENTRALIZADA */}
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'min(90vw, 420px)',
        maxHeight: 'calc(100dvh - 40px)', // respeita área útil em iOS
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        padding: 20,
        overflowY: 'auto',                 // rola se passar da tela
        zIndex: 100000,                    // acima do overlay
      }}
    >
      {/* Título + botão X */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 12,
        }}
      >
        <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Informações do Evento</h2>

        <button
          onClick={() => setMostrarModalEvento(false)}
          aria-label="Fechar"
          style={{
            backgroundColor: '#f5f5f5',
            border: '1px solid #ddd',
            color: '#555',
            width: 32,
            height: 32,
            borderRadius: 8,
            fontSize: 16,
            lineHeight: 1,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✕
        </button>
      </div>

      {/* Campos */}
      <input
        type="text"
        placeholder="Seu nome"
        value={nome}
        onChange={(e) => setNome(e.target.value)}
        style={{
          width: '100%',
          marginBottom: 10,
          padding: 10,
          borderRadius: 8,
          border: '1px solid #ccc',
          fontSize: 16,
        }}
      />

      <input
        type="text"
        placeholder="Local do evento"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        style={{
          width: '100%',
          marginBottom: 10,
          padding: 10,
          borderRadius: 8,
          border: '1px solid #ccc',
          fontSize: 16,
        }}
      />

      {/* DatePicker – versão que não abre teclado no iOS */}
      <DatePicker
  selected={startDate}
  onChange={(date) => {
    setStartDate(date);
    setData(date ? format(date, "dd-MM-yyyy") : "");
  }}
  locale="pt-BR"
  dateFormat="dd-MM-yyyy"
  withPortal
  portalId="datepicker-portal"
  shouldCloseOnSelect
  showPopperArrow={false}
  calendarClassName="dp-compact"
  wrapperClassName="dp-wrapper"
  popperProps={{ strategy: "fixed" }}
  popperModifiers={[
    {
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        padding: 8,
      },
    },
    {
      name: "flip",
      options: {
        fallbackPlacements: ["bottom", "top"],
      },
    },
  ]}
  onCalendarOpen={() => {
    document.activeElement?.blur?.();
  }}
  placeholderText="Data do evento"
  customInput={<CustomDateInput />}
/>

      {/* Ações */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
        <button
          onClick={() => setMostrarModalEvento(false)}
          style={{
            backgroundColor: '#ccc',
            color: '#333',
            border: 'none',
            borderRadius: 8,
            padding: '10px 20px',
            cursor: 'pointer',
            fontSize: 16,
          }}
        >
          Cancelar
        </button>

        <button
          onClick={() => {
            // evita qualquer foco ativo antes de validar/enviar
            document.activeElement?.blur();

            if (!nome.trim() || !local.trim() || !data.trim()) {
              toast.error('Por favor, preencha todos os campos antes de enviar.');
              return;
            }

            setMostrarModalEvento(false);
            enviarWhatsapp();
          }}
          style={{
            backgroundColor: '#25D366',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '10px 20px',
            cursor: 'pointer',
            fontSize: 16,
          }}
        >
          Confirmar
        </button>
      </div>
    </div>
  </>
)}
    </div>
  );
}

export default App;